// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-form{min-width:360px}.login-input-icon{color:rgba(0,0,0,0.25)}.login-join-button{width:100%}.test-connection-step{margin:1em;width:3em;vertical-align:top;display:inline-block}\n", ""]);
// Exports
module.exports = exports;
